import gql from 'graphql-tag'
import client from '../../stores/apollo'

interface Payload {
  data: {
    node: {
      spacesAssigned: number
    }
  }
}

export const query = gql`
  query DepartmentSpacesCount($id: ID!) {
    node(id: $id) {
      ... on Department {
        spacesAssigned
      }
    }
  }
`

export default function seatedCount(variables: { id: string }): Promise<number> {
  return client.gql
    .query({ query, variables })
    .then(({ data: { node } }: Payload) => node.spacesAssigned)
}
